export class SetCrumbs {
  static readonly type = "[Crumb] Set Crumbs";

  constructor(public crumbs: {
    title: string;
    subtitle: string;
  }) {
  }
}
